const getters = {
	/**
	 * Retorna a lista de IDs dos ativos selecionados.
	 * @returns {number[]} - IDs dos ativos selecionados.
	 */
	selectedAssets(state)
	{
		return state.selectedAssets;
	},

	/**
	 * Indica se a seleção de sinal está habilitada.
	 * @returns {boolean} - True se a seleção de sinal está habilitada, senão false.
	 */
	disableSignalSelection(state)
	{
		return !(state.selectedAssets.length > 0);
	},

	/**
	 * Indica se os ativos selecionados são válidos.
	 * @returns {boolean} - True se os ativos selecionados são válidos, senão false.
	 */
	isTurbinesSelectedValid(state)
	{
		return !!state.selectedAssets && state.selectedAssets.length !== 0;
	},

	/**
	 * Indica se as tendências são relacionadas a turbinas.
	 * @returns {boolean} - True se as tendências são relacionadas a turbinas, senão false.
	 */
	isTurbineTrends(state)
	{
		return !state.isHomeTrends && !state.isParkTrends;
	},

	/**
	 * Retorna o nome das turbinas selecionadas. Se passar de 5, adiciona reticências.
	 * @returns {string} - Nomes das turbinas selecionadas formatados.
	 */
	formatedSelectedAssetNames(state)
	{
		if (state.assets && state.assets.length > 0)
		{
			const assetNames = state.assets
				.filter(item => state.selectedAssets.includes(item.id))
				.map(item => item.name);

			if (assetNames.length > 5)
			{
				return `${assetNames.slice(0, 5).join(", ")}...`;
			}
			return assetNames.join(", ");
		}
		return "";
	},

	/**
	 * Retorna a lista de ativos filtrados com base na busca.
	 * @returns {Array} - Lista de ativos filtrados.
	 */
	filteredAssets(state)
	{
		if (state.searchQuery)
		{
			const query = state.searchQuery.toLowerCase();
			return state.assets.filter(asset => asset.name.toLowerCase().includes(query));
		}
		return state.assets;
	},
	/**
	 * Verifica se todos os ativos filtrados estão selecionados.
	 * @returns {boolean} - True se todos os ativos filtrados estão selecionados, senão false.
	 */
	allFilteredAssetsSelected(state, getters)
	{
		if (!Array.isArray(getters.filteredAssets) || !Array.isArray(state.selectedAssets)) return false;
	
		const filteredIds = getters.filteredAssets.map(asset => asset.id).filter(id => id != null);
		const selectedIdsSet = new Set(state.selectedAssets.map(asset => asset.id).filter(id => id != null));
	
		return filteredIds.length > 0 && filteredIds.every(id => selectedIdsSet.has(id));
	},

	/**
	 * Retorna o ícone correspondente ao estado de seleção dos ativos filtrados.
	 * @returns {string} - Nome do ícone a ser exibido.
	 */
	selectAllFilteredAssetsIcon(state, getters)
	{
		return getters.allFilteredAssetsSelected ? "mdi-close-box" : "mdi-checkbox-blank-outline";
	}
};

export default { getters };